<script>
export default {
  name: 'shortInfo',
  props: {
    item: {
      type: Object,
      default: () => {
        return {
          avatarName: '@作者名称',
          title: '标题',
          label: []
        };
      }
    }
  }
};
</script>

<template>
<div class="short-info-box">
  <div class="avatar-name">@{{ item.nick_name }}</div>
  <span class="title">
    {{ item.title }}
    <span
      v-for="(item, index) in item.label"
      :key="index"
  >#{{ item }}</span>
  </span>

</div>
</template>

<style scoped lang="scss">
.short-info-box {
  width: 87%;
  .avatar-name {
    font-size: 18px;
    font-weight: 500;
    color: #FFFFFF;
    font-family: "PingFang SC";
  }
  span {
    font-size: 16px;
    font-weight: 500;
    font-family: "PingFang SC";
    color: #FFFFFF;
    &.title {
      display: inline-block;
      width: 290px;
      margin-right: 4px;
    }
  }
}
</style>
